module.exports = __webpack_public_path__ + "static/media/18ECA36.56107387.jpg";